// extracted by mini-css-extract-plugin
export var activeFilterButton = "_oc-c";
export var backButton = "_oc-4";
export var backIcon = "_oc-5";
export var chevronShortcut = "_oc-6";
export var container = "_oc-1";
export var editor = "_oc-8";
export var editorWrapper = "_oc-7";
export var prefix = "_oc-2";
export var searchIcon = "_oc-3";
export var suffix = "_oc-9";
export var suffixContent = "_oc-a";
export var suffixText = "_oc-b";
export var wrapper = "_oc-0";